<div class="quote-step-tracker">
    <p class="quote-step-warning" *ngIf="warningKey && !hideWarning">
        {{ warningKey | translate : { storeName: storeName } }}
    </p>

    <div class="quote-step-cta-wrapper" *ngIf="showCta">
        <por-base-button [theme]="'primary'" [featureName]="'quote-step-cta'" [disabled]="buttonDisabled" (onclick)="onCtaClick()">
            <span>{{ ctaGlyph }}{{ buttonLabelKey | translate }}</span>
        </por-base-button>
    </div>

    <div class="quote-step-actions" *ngIf="showEsignButton">
        <por-base-button
            [theme]="'primary'"
            [featureName]="'quote-step-esign'"
            [class.quote-step-btn--complete]="status.eSign === 'complete'"
            [disabled]="status.eSign !== 'incomplete'"
            (onclick)="onStepClick('eSign', status.eSign)">
            <span>
                {{ stepGlyph(status.eSign) }}{{ 'SignYourContract' | translate }}
                <span aria-hidden="true">→</span>
            </span>
        </por-base-button>
    </div>
</div>
